/**
 * Lista de cargos — /configuracoes/acessos/cargos.
 *
 * Tabela com indentacao por nivel (hierarquia visivel logo na lista).
 * Cliques na linha abrem a ficha do cargo.
 */
import React, { useCallback, useEffect, useState } from "react";
import { FiPlus, FiRefreshCw } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

import { fetchCargos } from "../api";
import {
  ActionsBar,
  Card,
  CardHeader,
  CardTitle,
  EmptyMsg,
  ErrorMsg,
  Pill,
  PrimaryButton,
  SecondaryButton,
  Table,
} from "../styles.jsx";

function CargosLista() {
  const navigate = useNavigate();
  const { request, hasPermission } = useAuth();
  const podeCriar = hasPermission("cargo:create");
  const [estado, setEstado] = useState({ loading: true, cargos: [], error: null });

  const carregar = useCallback(async () => {
    setEstado((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const payload = await fetchCargos(request, true);
      setEstado({
        loading: false,
        cargos: payload?.resultados || [],
        error: null,
      });
    } catch (err) {
      setEstado({
        loading: false,
        cargos: [],
        error: err?.message || "Erro ao carregar cargos.",
      });
    }
  }, [request]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cargos</CardTitle>
        <ActionsBar>
          {podeCriar && (
            <PrimaryButton type="button" onClick={() => navigate("/configuracoes/acessos/cargos/novo")}>
              <FiPlus size={14} /> Novo cargo
            </PrimaryButton>
          )}
          <SecondaryButton type="button" onClick={carregar} disabled={estado.loading}>
            <FiRefreshCw size={14} /> Atualizar
          </SecondaryButton>
        </ActionsBar>
      </CardHeader>

      {estado.error && <ErrorMsg>{estado.error}</ErrorMsg>}

      {estado.loading ? (
        <EmptyMsg>Carregando...</EmptyMsg>
      ) : !estado.cargos.length ? (
        <EmptyMsg>Nenhum cargo cadastrado.</EmptyMsg>
      ) : (
        <Table $rowsClickable>
          <thead>
            <tr>
              <th>Cargo</th>
              <th>Nível</th>
              <th>Usuários</th>
              <th>MFA</th>
            </tr>
          </thead>
          <tbody>
            {estado.cargos.map((c) => (
              <tr
                key={c.id}
                onClick={() => navigate(`/configuracoes/acessos/cargos/${c.id}`)}
              >
                <td style={{ paddingLeft: 12 + (c.nivel || 0) * 18 }}>
                  <strong>{c.nome}</strong>
                  {c.descricao && (
                    <div style={{ fontSize: 12, opacity: 0.7 }}>{c.descricao}</div>
                  )}
                </td>
                <td>{c.nivel}</td>
                <td>
                  <Pill $tone="neutral">
                    {c.total_usuarios ?? "—"} usuário(s)
                  </Pill>
                </td>
                <td>
                  <Pill $tone={c.exige_mfa ? "info" : "neutral"}>
                    {c.exige_mfa ? "Exigido" : "—"}
                  </Pill>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Card>
  );
}

export default CargosLista;
